import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import {
    pageCustomBills,
    pageLoading,
    pagesSubtitleSelector,
    sessionKey,
} from '../../redux/selectors/pagesSelectors'
import { checkKey, setAccountFormIsVisible, setPageSubtitle } from '../../redux/actions/pagesActions';
import {
    carSelectedCustomBills,
    cartCartSelector,
    cartCurrencySelector, cartMainCustomBills,
} from '../../redux/selectors/cartSelector'
import Skeleton from 'react-loading-skeleton';

import CustomBillsList from './components/CustomBillsList'
import { useParams } from 'react-router-dom'
import CustomBill from './components/CustomBill'
import { setCartSelectedBills, setRenew } from '../../redux/actions/cartAction'

function CustomBillPage({
    checkKey,
    mainProduct,
    currency,
    pageSubtitle,
    setPageSubtitle,
    pageLoading,
    customBills,
    setCartSelectedBills,
    carSelectedCustomBills,
    setCartRenew
}) {
    useEffect(() => {
        checkKey();
    }, [checkKey]);

    useEffect(() => {
        setCartRenew(prevState => !prevState);
    }, [setCartRenew]);

    const { billId } = useParams();
    const currencyRUB = "RUB";
    useEffect(() => {
        const bills = customBills?.bills ?? [];
        setCartSelectedBills(bills.find((bill) => Number(bill.id) === Number(billId)));

    }, [customBills?.bills, billId]);

    const title = mainProduct?.translate?.h1;

    useEffect(() => {
        setPageSubtitle('');
    }, [mainProduct?.product_id]);

    return (
        <div className="container">
            <h1 className={'title-1 text--center mb-8 tablet-ml-16 tablet-mr-16'}>
                {pageLoading ? <Skeleton width={300}/> : title}
            </h1>

            <div className={'subtitle mb-36 tablet-mb-16 text--center'}>
                {pageSubtitle}
            </div>

            {!billId ? <CustomBillsList customBills={customBills} pageLoading={pageLoading}/>
                : <CustomBill currentBill={carSelectedCustomBills} pageLoading={pageLoading}
                              lang={customBills.translate}/>}

            {currency?.currency && currency?.currency === currencyRUB && (
                <div className={'notification__message'}>
                    <p>
                        Если у вас возникли проблемы с оплатой в рублях, то
                        воспользуйтесь сервисом{' '}
                        <a href="https://cleantalk-shop.ru" target="_blank" rel="noreferrer">cleantalk-shop.ru</a> или{' '}
                        <a href="https://pay-saas.ru" target="_blank" rel="noreferrer">pay-saas.ru</a>.
                    </p>
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessionKey: sessionKey(state),
    mainProduct: cartMainCustomBills(state),
    cart: cartCartSelector(state),
    currency: cartCurrencySelector(state),
    pageSubtitle: pagesSubtitleSelector(state),
    pageLoading: pageLoading(state),
    customBills: pageCustomBills(state),
    carSelectedCustomBills: carSelectedCustomBills(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setPageSubtitle: (value) => dispatch(setPageSubtitle(value)),
    setCartSelectedBills: (value) => dispatch(setCartSelectedBills(value)),
    setCartRenew: (value) => dispatch(setRenew(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomBillPage);
